import React, { createContext, useContext, useState } from "react";

const OnboardingContext = createContext(null);

export const OnboardingProvider = ({ children }) => {
  const [sessionId, setSessionId] = useState(sessionStorage.getItem("onboarding_session_id"));
  const [sessionToken, setSessionToken] = useState(sessionStorage.getItem("onboarding_session_token"));
  const [sessionData, setSessionData] = useState(null);
  const [theme, setTheme] = useState(null);
  const [subscriptionLines, setSubscriptionLines] = useState([]);
  // New state to hold claim information and metadata for build/device claims
  const [claimData, setClaimData] = useState(null);
  const [claimMeta, setClaimMeta] = useState(null);

  const updateSessionId = (id) => {
    setSessionId(id);
    sessionStorage.setItem("onboarding_session_id", id);
  };

  const updateSessionToken = (token) => {
    setSessionToken(token);
    sessionStorage.setItem("onboarding_session_token", token);
  };

  const clearSession = () => {
    setSessionToken(null);
    setSessionId(null);
    setSessionData(null);
    setTheme(null);
    setSubscriptionLines([]);
    setClaimData(null);
    setClaimMeta(null);
    sessionStorage.removeItem("onboarding_session_token");
    sessionStorage.removeItem("onboarding_session_id");
  };

  return (
    <OnboardingContext.Provider
      value={{
        sessionToken,
        updateSessionToken,
        sessionData,
        setSessionData,
        theme,
        setTheme,
        subscriptionLines,
        setSubscriptionLines,
        // expose claim data and meta
        claimData,
        setClaimData,
        claimMeta,
        setClaimMeta,
        clearSession,
        sessionId,
        updateSessionId
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
};

export const useOnboarding = () => {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error("useOnboarding must be used within an OnboardingProvider");
  }
  return context;
};
